
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.CaseSummarySms">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-case-summary-sms-modal [entry]="data.entry" [stakeholder]="data.stakeholder" (closed)="close()"></app-case-summary-sms-modal>
      </mat-dialog-content>
</div>
